import { tokens } from "@blurb/codex-react";
import { Flex } from "@rpi/openapi-core";
import React from "react";

interface FieldFrameProps {
  children: React.ReactNode;
  gap?: number | string;
  padding?: number | string;
  "data-testid"?: string;
}

/** Bordered container that frames the data rows in the Account and Organization cards, and file rows. */
export const FieldFrame: React.FC<FieldFrameProps> = ({ children, gap = 24, padding = 16, ...rest }) => (
  <Flex.Column
    {...rest}
    gap={gap}
    fullWidth
    sx={{
      padding,
      border: `1px solid ${tokens.color.semantic.border.faint}`,
      borderRadius: tokens.radius.sm,
    }}
  >
    {children}
  </Flex.Column>
);
